import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import { connect } from 'react-redux';
import ToolTip from '../../ToolTipIcon/ToolTip';

const FileEdder = memo(props => {
  const { downloadClicked, constants } = props;

  return (
    <div data-test="edd-actions" className="mt-8">
      <div className="flex  md:space-x-4 md:ml-0 justify-between md:justify-start">
        {constants.edd_docs_link && (
          <ToolTip toolText="Read the docs" placement="bottom">
            <button
              aria-label="Read the docs"
              type="button"
              className="duration-500 hover:scale-105 w-[50px] text-[#0A364B] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
              onClick={() => {
                window.open(constants.edd_docs_link, '_blank');
              }}
            >
              <img
                src="/assets/images/icons/book.svg"
                alt="Read the docs"
                className="w-[30px] h-[30px] max-w-[30px] max-h-[30px]"
              />
            </button>
          </ToolTip>
        )}
        <ToolTip toolText="Download file" placement="bottom">
          <button
            aria-label="download"
            type="button"
            className="duration-500 hover:scale-105 w-[50px] text-[#0A364B] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
            onClick={downloadClicked}
          >
            <img
              src="/assets/images/icons/download.svg"
              alt="Download"
              className="w-[30px] h-[30px] max-w-[30px] max-h-[30px]"
            />
          </button>
        </ToolTip>
      </div>
    </div>
  );
});

FileEdder.propTypes = {
  downloadClicked: PropTypes.func,
  constants: PropTypes.shape({
    edd_docs_link: PropTypes.string,
  }),
};

const mapStateToProps = state => ({
  constants: state.constants?.data || {},
});

export default withRouter(connect(mapStateToProps)(FileEdder));
